// Legacy property for identifying typed arrays (Float64Array)
export const LEGACY_TYPED_ARRAY_LABEL = "$$IS_TYPED_ARRAY$$";

// New property for identifying array type
export const TYPED_ARRAY_LABEL = "$$TA_TYPE$$";

// Enum for array buffer types
export enum ArrayBufferType {
  INT8 = "I8",
  UINT8 = "U8",
  UINT8_CLAMPED = "U8C",
  INT16 = "I16",
  UINT16 = "U16",
  INT32 = "I32",
  UINT32 = "U32",
  FLOAT32 = "F32",
  FLOAT64 = "F64",
  INT64 = "I64",
  UINT64 = "U64",
}

// helper types

type RegularArrayBufferConstructor = new (array: Iterable<number>) => ArrayBufferView;
type BigArrayBufferConstructor = new (array: Iterable<bigint>) => ArrayBufferView;
type ArrayBufferConstructor = RegularArrayBufferConstructor | BigArrayBufferConstructor;
type TypeToConstructorTable = { [key in ArrayBufferType]: ArrayBufferConstructor };
type ConstructorToTypeTable = { [key: string]: ArrayBufferType };

// Map from type enum to constructor
export const TYPE_TO_ARRAY_CONSTRUCTOR: TypeToConstructorTable = {
  [ArrayBufferType.INT8]: Int8Array,
  [ArrayBufferType.UINT8]: Uint8Array,
  [ArrayBufferType.UINT8_CLAMPED]: Uint8ClampedArray,
  [ArrayBufferType.INT16]: Int16Array,
  [ArrayBufferType.UINT16]: Uint16Array,
  [ArrayBufferType.INT32]: Int32Array,
  [ArrayBufferType.UINT32]: Uint32Array,
  [ArrayBufferType.FLOAT32]: Float32Array,
  [ArrayBufferType.FLOAT64]: Float64Array,
  [ArrayBufferType.INT64]: BigInt64Array,
  [ArrayBufferType.UINT64]: BigUint64Array,
};

// Map from constructor to type enum
export const ARRAY_CONSTRUCTOR_TO_TYPE: ConstructorToTypeTable = Object.entries(TYPE_TO_ARRAY_CONSTRUCTOR).reduce(
  (acc, [type, constructor]) => {
    acc[constructor.name] = type as ArrayBufferType;
    return acc;
  },
  {} as ConstructorToTypeTable,
);

// Array buffer types that are considered "big" (i.e., use BigInt)
export const IS_BIGINT_ARRAY: { [key in ArrayBufferType]?: boolean } = {
  [ArrayBufferType.INT64]: true,
  [ArrayBufferType.UINT64]: true,
};
